/**
 * CSRF Protection Plugin
 *
 * Initializes CSRF protection by fetching the CSRF cookie from Laravel Sanctum
 * before making any authenticated API requests.
 */
export default defineNuxtPlugin(async () => {
  // Skip CSRF initialization on server-side
  if (!process.client) return

  const config = useRuntimeConfig()

  // Determine the Laravel base URL (without /api/v1)
  // In development with proxy: apiBase is '/api/v1', so laravelBaseUrl is '' (relative)
  // In production: apiBase is 'https://api.example.com/api/v1', extract base
  const apiBase = config.public.apiBase || '/api/v1'
  const laravelBaseUrl = apiBase.startsWith('/')
    ? '' // Relative path for dev proxy
    : apiBase.replace('/api/v1', '')

  const backendUrl = (config.public.backendUrl || '').replace(/\/$/, '')

  const candidateUrls = [
    `${laravelBaseUrl}/sanctum/csrf-cookie`,
    backendUrl ? `${backendUrl}/sanctum/csrf-cookie` : '',
  ].filter((url, index, arr) => Boolean(url) && arr.indexOf(url) === index)

  try {
    let initialized = false
    let lastError: unknown = null

    for (const url of candidateUrls) {
      try {
        await $fetch(url, {
          credentials: 'include',
        })
        initialized = true
        break
      } catch (error) {
        lastError = error
      }
    }

    if (!initialized) {
      throw lastError ?? new Error('Failed to initialize CSRF cookie')
    }

    if (process.dev) {
      console.log('✅ CSRF protection initialized')
    }
  } catch (error) {
    if (process.dev) {
      console.warn('⚠️ Failed to initialize CSRF protection:', error)
    }
  }
})

